import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import Rbac from 'src/containers/rbac';
import { ROUTES } from 'src/config';
import { connect } from 'react-redux';

const login = (accessToken, refreshToken) => accessToken && refreshToken;

function ProtectedRoute({ role, siteRole, component: Component, allowedRoles = [], deniedRoles = [], ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!login(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken'))) {
          return <Redirect to={{ pathname: '/login', state: { from: props.path } }} />;
        }

        if ((allowedRoles.length || deniedRoles.length) && !role && !siteRole) return null;

        if (deniedRoles.length && (deniedRoles.includes(role) || deniedRoles.includes(siteRole))) {
          return <Redirect to={{ pathname: ROUTES.HOME, state: { from: props.path } }} />;
        }

        if (allowedRoles.length) {
          return (
            <Rbac
              roles={allowedRoles}
              fallback={<Redirect to={{ pathname: ROUTES.HOME, state: { from: props.path } }} />}
            >
              <Component {...rest} {...props} />
            </Rbac>
          );
        }

        return <Component {...rest} {...props} />;
      }}
    />
  );
}

const mapStateToProps = ({ app, ...ownProps }) => ({
  role: app?.profile?.role,
  siteRole: app?.profile?.siteRole,
  ...ownProps,
});

const ConnectedProtectedRoute = connect(mapStateToProps)(ProtectedRoute);
export { ConnectedProtectedRoute as ProtectedRoute };

export function LoginRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        login(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken')) ? (
          <Redirect to={{ pathname: '/', state: { from: props.path } }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

ProtectedRoute.propTypes = {
  role: PropTypes.string.isRequired,
  siteRole: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  path: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/require-default-props
  deniedRoles: PropTypes.arrayOf(PropTypes.string),
};

LoginRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  path: PropTypes.string.isRequired,
};
